export const Config = {
    WINDOW_WIDTH: 780,
};